module.exports = __webpack_public_path__ + "static/media/affiliate-profile-new.10e1bcef.png";